import styled from "styled-components";
import IconGroup from "../components/IconGroup";

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: var(--fd-space-space-1);
`;

export const Row = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
`;

export const StyledIconGroup = styled(IconGroup)`
  padding: 0;
`;
